"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickOrderScan = void 0;
const core_1 = require("@material-ui/core");
const ndc_barcode_scan_1 = require("client/components/ndc-barcode-scan");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const styles = core_1.createStyles({});
const decorate = core_1.withStyles(styles);
let QuickOrderScanUnstyled = class QuickOrderScanUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.scannedData = [];
        this.renderPreview = (data) => {
            console.info("previewdata triggered");
            return React.createElement("div", null, "Preview data goes here");
        };
        this.handleSubmit = (scannedList) => {
            const ndcs = scannedList.map((scannedItem) => ({
                pkg: scannedItem[0],
                qty: scannedItem[1].length
            }));
            this.props.onSubmit(ndcs);
        };
    }
    componentDidMount() {
        console.info("cdm qos");
    }
    render() {
        return (React.createElement(ndc_barcode_scan_1.NdcBarcodeScan, { onCancel: this.props.onCancel, onSubmit: this.handleSubmit, renderPreview: this.renderPreview }));
    }
};
__decorate([
    mobx_1.observable
], QuickOrderScanUnstyled.prototype, "scannedData", void 0);
QuickOrderScanUnstyled = __decorate([
    mobx_react_1.observer
], QuickOrderScanUnstyled);
exports.QuickOrderScan = decorate(QuickOrderScanUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/quick-order/components/quick-order-scan/quick-order-scan.tsx
// module id = 3605
// module chunks = 0